import { Axios } from '../../api';
import { APP_VERSION_KEY, REGISTERS_API_URL } from '../../constants';
import { logger } from '../../log';
import { getMostRecentTimestamp } from '../../timestamps';
import { checkIfSignedInAndOnline } from '../utils';
import { getBatteryLevel } from './battery';
import { getNetworkDetails } from './network';
import { type RegisterInfo } from './types';

export async function logRegisterInfoJobHandler() {
    const shouldRun = checkIfSignedInAndOnline();

    if (!shouldRun) {
        return;
    }

    try {
        const batteryLevel = await getBatteryLevel();
        const networkDetails = await getNetworkDetails();
        const lastSync = await getMostRecentTimestamp();
        const registerVersion = localStorage.getItem(APP_VERSION_KEY) ?? '';

        const data: RegisterInfo = {
            batteryLevel,
            lastSync,
            networkDetails,
            registerVersion,
        };

        await Axios.put(REGISTERS_API_URL.REGISTER.INFO, data);
    } catch (error) {
        logger.error(
            error instanceof Error
                ? error.message
                : 'Failed to log register info',
        );
    }
}
